import { render } from "./SidebarMenu.vue?vue&type=template&id=372009b9"
const script = {}

import exportComponent from "E:\\wamp64\\www\\tusacan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__